import React, { forwardRef, Ref } from 'react';
import classnames from 'classnames';
import { Icon } from '@eika/icon';

import Button from '../Button';

import { LinkButtonTypes } from '../ButtonTypes';
import { SharedButtonProps } from '../Props';

export interface LinkButtonProps extends SharedButtonProps<LinkButtonTypes> {
    iconOnRightSide?: boolean;
}

const LinkButton = forwardRef(
    (
        { children, iconOnRightSide = false, buttonType = 'link', icon, ...rest }: LinkButtonProps,
        ref: Ref<HTMLButtonElement>
    ): JSX.Element => (
        <Button
            {...rest}
            icon={iconOnRightSide ? undefined : icon}
            buttonType={buttonType}
            ref={ref}
            className={classnames(rest.className, { 'button--link__icon-right': iconOnRightSide })}
        >
            <>
                <span
                    className={classnames('sgw-link__text', {
                        'sgw-link__text--icon-visible': icon && !iconOnRightSide,
                    })}
                >
                    {children}
                    {iconOnRightSide && icon && <Icon type={icon} className="icon--22" />}
                </span>
            </>
        </Button>
    )
);

export default LinkButton;
